import { combineReducers } from 'redux'

import * as h2Api from '../../h2Api'
import * as actions from '../../actions/admin/adminCertificationActions'

export default combineReducers({
  listRequest: h2Api.restReducer(actions.LIST, { result: {} }),
  promotionRequest: h2Api.restReducer(actions.TOGGLE_PROMOTION)
})
